import _objectSpread from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import dayjs from 'dayjs';
export default {
  name: 'mng_admin',
  components: {
    labSel: function labSel() {
      return import('../org/lab_sel');
    }
  },
  data: function data() {
    return {
      dayjs: dayjs,
      currentUser: localStorage.getItem('userId'),
      accountCategory: localStorage.getItem('accountCategory'),
      roleDatas: [],
      pageConfig: {
        editPageName: '用户',
        addFunName: 'userAdd',
        modifyFunName: 'userModify',
        queryFunName: 'userQuery',
        detailFunName: 'userDetailHasRole',
        disableFunName: 'userDisable',
        unDisableFunName: 'userUnDisable',
        unLockFunName: 'userUnLock',
        resetPasswordFunName: 'userResetPassword',
        delUserFunName: 'userDel',
        roleAllQueryFunName: 'roleQueryAll'
      },
      searchForm: {
        page: 1,
        limit: 10,
        searchKey: null
        // , category: 'Admin'
        ,
        sortField: 'create_time'
      },
      formData: {
        id: null,
        account: null,
        nickname: null,
        headImage: null,
        category: 'Business',
        state: 'Active',
        roleIds: [],
        userRoles: [],
        labId: null
      },
      rules: {
        account: [{
          required: true,
          message: '管理员帐号不能为空',
          trigger: 'blur'
        }],
        labId: [{
          required: true,
          message: '请选择所属企业',
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        }]
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      editDialogShow: false,
      editDialogTitle: '',
      formLabelWidth: '80px',
      emptyFormData: {},
      labShow: false,
      userInfo: {} //用户信息
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.emptyFormData = JSON.parse(JSON.stringify(this.formData));
    this.userInfo = JSON.parse(localStorage.getItem('userData'));
    if (this.userInfo.category == 'Business') {
      this.$set(this.formData, 'category', 'Business');
      this.$set(this.formData, 'labId', this.userInfo.labId);
      this.$set(this.formData, 'labName', this.userInfo.labName);
      this.searchForm.category = 'Business';
    }
    this.$api[this.pageConfig.roleAllQueryFunName]().then(function (res) {
      _this.roleDatas = res.data;
      _this.query();
    });
  },
  methods: {
    beforeCommand: function beforeCommand(index, row, command) {
      return {
        index: index,
        row: row,
        command: command
      };
    },
    moreButton: function moreButton(command) {
      switch (command.command) {
        case 'unLock':
          // 解除锁定
          this.unLock(command.row.id);
          break;
        case 'disable':
          // 封禁用户
          this.disableUser(command.row.id);
          break;
        case 'unDisable':
          // 解封用户
          this.unDisableUser(command.row.id);
          break;
        case 'resetPassword':
          // 重置密码
          this.resetPassword(command.row.id);
          break;
        case 'del':
          // 清理用户
          this.delUser(command.row.id);
          break;
      }
    },
    unLock: function unLock(id) {
      var _this2 = this;
      this.$confirm('确定解锁当前用户吗').then(function () {
        _this2.$api[_this2.pageConfig.unLockFunName](id).then(function (res) {
          if (res.data) {
            _this2.$message.success('解锁成功');
            _this2.query();
          } else {
            _this2.$message.error('解锁失败');
          }
        });
      });
    },
    disableUser: function disableUser(id) {
      var _this3 = this;
      this.$confirm('确定封禁当前用户吗').then(function () {
        _this3.$api[_this3.pageConfig.disableFunName](id).then(function (res) {
          if (res.data) {
            _this3.$message.success('封禁成功');
            _this3.query();
          } else {
            _this3.$message.error('封禁失败');
          }
        });
      });
    },
    unDisableUser: function unDisableUser(id) {
      var _this4 = this;
      this.$confirm('确定解禁当前用户吗').then(function () {
        _this4.$api[_this4.pageConfig.unDisableFunName](id).then(function (res) {
          if (res.data) {
            _this4.$message.success('解禁成功');
            _this4.query();
          } else {
            _this4.$message.error('解禁失败');
          }
        });
      });
    },
    resetPassword: function resetPassword(id) {
      var _this5 = this;
      this.$confirm('确定重置当前用户密码吗').then(function () {
        _this5.$api[_this5.pageConfig.resetPasswordFunName](id).then(function (res) {
          if (res.data) {
            _this5.$message.success('重置成功');
            _this5.query();
          } else {
            _this5.$message.error('重置失败');
          }
        });
      });
    },
    delUser: function delUser(id) {
      var _this6 = this;
      this.$confirm('确定删除用户吗？删除后将不能恢复').then(function () {
        _this6.$confirm('请再次确认，是否删除当前用户？').then(function () {
          _this6.$confirm('请谨慎操作！！！最后确认是否删除当前用户？').then(function () {
            _this6.$api[_this6.pageConfig.delUserFunName](id).then(function (res) {
              if (res.data) {
                _this6.$message.success('删除成功');
                _this6.query();
              } else {
                _this6.$message.error('删除失败');
              }
            });
          });
        });
      });
    },
    initFormData: function initFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      paramData.roleIds = [];
      this.formData = paramData;
      if (typeof this.$refs['formDataVerify'] !== 'undefined') {
        this.$refs['formDataVerify'].clearValidate();
      }
    },
    saveFormDataProcess: function saveFormDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));
      return saveFormData;
    },
    beforeFileUpload: function beforeFileUpload(file) {
      var isImage = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type);
      if (!isImage) {
        this.$message.error('文件必须是图片格式');
      }
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('图片大小不超过5M！');
      }
      return isImage && isLt5M;
    },
    upload: function upload(_ref) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var file;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              file = _ref.file;
              _this7.$api.aliOssSign(localStorage.getItem('userId')).then(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return _this7.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        _this7.formData.headImage = _context.sent;
                      case 3:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    previewFile: function previewFile() {
      window.open(this.formData.headImage);
    },
    removeFile: function removeFile() {
      this.formData.headImage = '';
    },
    add: function add() {
      this.editDialogTitle = this.pageConfig.editPageName + '新增';
      this.editDialogShow = true;
    },
    edit: function edit(id) {
      var _this8 = this;
      this.$api[this.pageConfig.detailFunName](id, true).then(function (res) {
        _this8.initFormData(res.data);
        if (res.data.userRoles && res.data.userRoles.length > 0) {
          for (var i = 0; i < res.data.userRoles.length; i++) {
            _this8.formData.roleIds.push(res.data.userRoles[i].id);
          }
        }
        _this8.editDialogTitle = _this8.pageConfig.editPageName + '维护';
        _this8.editDialogShow = true;
      });
    } // 选择企业
    ,
    labSel: function labSel(data) {
      if (data) {
        this.formData.labId = data.id;
        this.$set(this.formData, 'labName', data.name);
      }
      this.labShow = false;
    },
    del: function del(id) {
      var _this9 = this;
      this.$confirm('确定要删除吗').then(function () {
        _this9.$api[_this9.pageConfig.delFunName](id).then(function (res) {
          if (res.data) {
            _this9.$message.success('删除成功');
            _this9.query();
          } else {
            _this9.$message.error('删除失败');
          }
        });
      });
    },
    query: function query() {
      var _this0 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryFunName](this.searchForm).then(function (res) {
        _this0.tableData = res.data || [];
        _this0.totalCount = res.count;
        _this0.queryLoading = false;
      });
    },
    submitFormData: function submitFormData() {
      var _this1 = this;
      this.$refs['formDataVerify'].validate(function (valid) {
        if (valid) {
          if (_this1.formData.id) {
            _this1.$api[_this1.pageConfig.modifyFunName](_this1.saveFormDataProcess(_objectSpread(_objectSpread({}, _this1.formData), {}, {
              account: _this1.formData.phone
            }))).then(function (res) {
              if (res.data) {
                _this1.$message.success('编辑成功');
                _this1.initFormData(_this1.emptyFormData);
                _this1.editDialogShow = false;
                _this1.query();
              } else {
                _this1.$message.error('编辑失败');
              }
            });
          } else {
            _this1.$api[_this1.pageConfig.addFunName](_this1.saveFormDataProcess(_objectSpread(_objectSpread({}, _this1.formData), {}, {
              account: _this1.formData.phone
            }))).then(function (res) {
              if (res.data) {
                _this1.$message.success('新增成功');
                _this1.initFormData(_this1.emptyFormData);
                _this1.editDialogShow = false;
                _this1.query();
              } else {
                _this1.$message.error('新增失败');
              }
            });
          }
        }
      });
    },
    closeEditDialogShow: function closeEditDialogShow() {
      this.editDialogTitle = '';
      this.editDialogShow = false;
      this.initFormData(this.emptyFormData);
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'create_time';
      this.query();
    }
  }
};